import { useAppAuth, useAppAuthActions } from '../hooks/useAppAuth';
import TenantSwitcher from '../components/TenantSwitcher';

export default function TenantNotFound() {
  const { user } = useAppAuth();
  const { logout } = useAppAuthActions();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-6 rounded-lg border p-8 shadow-sm">
        <div className="text-center space-y-2">
          <p className="text-6xl font-light text-muted-foreground">Oh No!</p>
          <h1 className="text-xl font-semibold">Tenant Not Found</h1>
          <p className="text-sm text-muted-foreground">
            This tenant no longer exists or you don't have access to it.
          </p>
        </div>

        {user && (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground text-center">
              Switch to another account:
            </p>
            <TenantSwitcher />
          </div>
        )}

        <div className="text-center">
          <button
            onClick={() => logout()}
            className="text-sm text-muted-foreground underline hover:text-foreground"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
